import InputMask from '@amzn/meridian/input/mask';

export const emptyDateYyyyMmMaskStr = '    -  ';

export const emptyDateYyyyMmDdMaskStr = '    -  -  ';

export const dateYyyyMmMask = new InputMask('####-##');

export const dateYyyyMmDdMask = new InputMask('####-##-##');
